(function($) {
  var unitSymbols = {
    USD: '$',
    THB: '฿',
  }

  var getRatesApi = function(currency) {
    return $.ajax({
      type: 'GET',
      url: local.ajaxurl,
      data: {
        action: 'exchangerate',
        base: 'THB',
        symbols: currency
      }
    })
  }
  
  $('[data-exchange]').each( function() {
    var amount = $(this).data('exchange');
    var currency = $(this).data('exchangeGet') || 'USD';

    $.when( getRatesApi(currency) ).done( rates => {
      var data = {};
      try {
        data = JSON.parse(rates);
      } catch (error) {
        console.log(error)
        return
      }

      var rate = Math.round( Number(amount.replace(/,/g, '')) * data.rates[currency] )
      var result = `${numeral(rate).format()} <span class="small">${currency}</span>`

      this.innerHTML = result
    })
  } );
})(jQuery);